import api from "../store/api.ts";
import {unwrapData} from "../store/apiResponse.ts";


export interface LinkPreview {
    title?: string;
    description?: string;
    image?: string;
    imageUrl?: string;
    url: string;
    favicon?: string;
    siteName?: string;
    author?: string;
    publishedTime?: string;
    video?: boolean;
    audio?: boolean;
    success?: boolean;
}

export interface LinkPreviewRequest {
    url: string;
}

/**
 * URL regex pattern to detect URLs in text
 */
const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;

/**
 * Extracts all URLs from a text string
 */
export function extractUrls(text: string): string[] {
    if (!text) return [];
    const matches = text.match(URL_REGEX);
    return matches || [];
}

/**
 * Checks if text contains any URLs
 */
export function containsUrls(text: string): boolean {
    return URL_REGEX.test(text);
}

/**
 * Gets the first URL from text, or null if none found
 */
export function getFirstUrl(text: string): string | null {
    const urls = extractUrls(text);
    return urls.length > 0 ? urls[0] : null;
}

export const linkPreviewsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getLinkPreview: builder.mutation<LinkPreview, LinkPreviewRequest>({
            query: (body) => ({
                url: '/api/v1/link-previews',
                method: 'POST',
                body,
            }),
            transformResponse: (response: LinkPreview | { data: LinkPreview }) => unwrapData(response),
        }),
    }),
});

export const {
    useGetLinkPreviewMutation,
} = linkPreviewsApi;
